(function () {
    'use strict';

    angular.module('swif.framework')
    .filter('swifFormatDate', swifFormatDate)
    .filter('swifFormatDatetime', swifFormatDatetime)
    .filter('swifFormatHours', swifFormatHours)
    .filter('swifTimeago', swifTimeago);


    
    function swifFormatDate(swifMomentUtility) {
        'ngInject';
        return function (input, outputFormat) {
            return swifMomentUtility.formatDate(input, outputFormat);
        };
    }
    
    function swifFormatDatetime(swifMomentUtility) {
        'ngInject';
        return function (input, outputFormat) {
            return swifMomentUtility.formatDatetime(input, outputFormat);
        };
    }
    
    function swifFormatHours(swifMomentUtility) {
        'ngInject';
        return function (input) {
            return swifMomentUtility.formatHours(input);
        };
    }
    
    function swifTimeago(swifMomentUtility) {
        'ngInject';
        return function (input) {
            return swifMomentUtility.timeago(input);
        };
    }


})();
